module.exports = __webpack_public_path__ + "static/img/shushi.84de238.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shushi.gif
// module id = axoW
// module chunks = 1